// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls___c2e6","OrderButton":"BuildControls_OrderButton__3pDZO","enable":"BuildControls_enable__2cBMw"};